(function () {
	function focusSearchField() {
		var input = document.querySelector('.siteHeader .searchForm input[name="q"]');
		if (!input) {
			var root =
				typeof Shopify !== 'undefined' &&
				Shopify.routes &&
				Shopify.routes.root != null
					? String(Shopify.routes.root).replace(/\/?$/, '/')
					: '/';
			window.location.href = root + 'search?type=product';
			return;
		}
		input.focus({ preventScroll: false });
		try {
			input.scrollIntoView({ block: 'center', behavior: 'smooth' });
		} catch (e) {
			input.scrollIntoView(true);
		}
	}

	function onReady(fn) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', fn);
		} else {
			fn();
		}
	}

	onReady(function () {
		document.querySelectorAll('.js-mobile-bottom-search').forEach(function (btn) {
			btn.addEventListener('click', function () {
				focusSearchField();
			});
		});
	});
})();
